import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@core/services/http/http.service';
import { HostConfigService } from '@core/services/host-config.service';
import { SolicitudAprobacionResumen, ConteoSolicitudes } from '../models';

export interface FiltrosSolicitudesAprobacion {
  tipoCambio?: string;
  estado?: string;
  fechaDesde?: string;
  fechaHasta?: string;
  solicitante?: string;
  tipoDocumento?: string;
}

@Injectable()
export class SolicitudesAprobacionService {
  private readonly http = inject(HttpService);
  private readonly hostConfig = inject(HostConfigService);

  private get baseUrl(): string {
    return `${this.hostConfig.getCurrentBaseServiceUrl()}plantillas/solicitudes-aprobacion`;
  }

  private static construirQueryParams(filtros?: FiltrosSolicitudesAprobacion): string {
    if (!filtros) return '';
    const params: string[] = [];
    if (filtros.tipoCambio) params.push(`tipoCambio=${encodeURIComponent(filtros.tipoCambio)}`);
    if (filtros.estado) params.push(`estado=${encodeURIComponent(filtros.estado)}`);
    if (filtros.fechaDesde) params.push(`fechaDesde=${encodeURIComponent(filtros.fechaDesde)}`);
    if (filtros.fechaHasta) params.push(`fechaHasta=${encodeURIComponent(filtros.fechaHasta)}`);
    if (filtros.solicitante) params.push(`solicitante=${encodeURIComponent(filtros.solicitante)}`);
    if (filtros.tipoDocumento) params.push(`tipoDocumento=${encodeURIComponent(filtros.tipoDocumento)}`);
    return params.join('&');
  }

  public obtenerSolicitudes(filtros?: FiltrosSolicitudesAprobacion): Observable<SolicitudAprobacionResumen[]> {
    let url = this.baseUrl;
    const params = SolicitudesAprobacionService.construirQueryParams(filtros);
    if (params) {
      url += `?${params}`;
    }
    return this.http.doGet<SolicitudAprobacionResumen[]>(url);
  }

  public contarPendientes(): Observable<ConteoSolicitudes> {
    return this.http.doGet<ConteoSolicitudes>(`${this.baseUrl}/conteo-pendientes`);
  }
}
